import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import UploadPage from "@/components/UploadPage";
import ProcessingPage from "@/components/ProcessingPage";
import PreviewPage from "@/components/PreviewPage";
import ExportTest from "@/components/ExportTest";

function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [processingResult, setProcessingResult] = useState(null);

  const handleUploadSuccess = (result) => {
    setProcessingResult(result);
    setCurrentStep(2);
  };

  const handleProcessingComplete = () => {
    setCurrentStep(3);
  };

  const handleBackToUpload = () => {
    setCurrentStep(1);
    setProcessingResult(null);
  };

  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={
              <div className="min-h-screen">
                {/* Header */}
                <header className="border-b border-slate-200 bg-white sticky top-0 z-50 backdrop-blur-md">
                  <div className="max-w-7xl mx-auto px-6 py-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4">
                        <div className="w-8 h-8 bg-emerald-600 rounded" data-testid="logo"></div>
                        <h1 className="text-xl font-bold tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }} data-testid="app-title">
                          The Digital Refinery
                        </h1>
                      </div>
                      <div className="flex items-center space-x-2 text-sm text-slate-600" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                        <div className={`px-2 py-1 rounded ${currentStep === 1 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100'}`} data-testid="step-1-indicator">
                          1. Upload
                        </div>
                        <div className={`px-2 py-1 rounded ${currentStep === 2 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100'}`} data-testid="step-2-indicator">
                          2. Process
                        </div>
                        <div className={`px-2 py-1 rounded ${currentStep === 3 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100'}`} data-testid="step-3-indicator">
                          3. Export
                        </div>
                      </div>
                    </div>
                  </div>
                </header>

                {/* Main Content */}
                <main className="max-w-7xl mx-auto px-6 py-8">
                  {currentStep === 1 && (
                    <div className="space-y-8">
                      <UploadPage 
                        onUploadSuccess={handleUploadSuccess}
                        data-testid="upload-page"
                      />
                      <ExportTest />
                    </div>
                  )}
                  {currentStep === 2 && processingResult && (
                    <ProcessingPage 
                      result={processingResult}
                      onComplete={handleProcessingComplete}
                      data-testid="processing-page"
                    />
                  )}
                  {currentStep === 3 && processingResult && (
                    <PreviewPage 
                      result={processingResult}
                      onBackToUpload={handleBackToUpload}
                      data-testid="preview-page"
                    />
                  )}
                </main>
              </div>
            } 
          />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;